import React from "react";
import { Button, Flex, Form, Image, Input, Tooltip, Typography } from "antd";
import { ecType } from "./ec.types";
import { LanguageKey } from "../constants/creditsName";
import resetIcon from "../../../../../assets/icons/reset.svg";

const { Text } = Typography;

interface CreditsNameInputProps {
  language: LanguageKey;
  label: string;
  placeholder: string;
  enableCustomCreditsName: boolean;
  onReset: (language: LanguageKey) => void;
  t: (key: string) => string;
}

const CreditsNameInput: React.FC<CreditsNameInputProps> = ({
  language,
  label,
  placeholder,
  enableCustomCreditsName,
  onReset,
  t
}) => {
  return (
    <Flex vertical gap="4px">
      <Text className="body-medium text-o-body">{label}</Text>
      <Flex gap="8px" className="items-center">
        <Form.Item<ecType>
          name={["custom_credits_name_mapping", language]}
          className="mb-0 flex-1"
          rules={[
            {
              required: enableCustomCreditsName,
              message: t("field_is_required"),
            },
          ]}
          normalize={(value) => value?.trim() || ""}
        >
          <Input
            placeholder={placeholder}
            size="small"
          />
        </Form.Item>
        <Tooltip title={t('reset_to_default')} placement="top" color="white" overlayStyle={{ color: '#000' }}>
          <Button
            type="text"
            size="small"
            onClick={() => onReset(language)}
            className="p-1 min-w-0"
          >
            <Image 
              src={resetIcon} 
              width={14} 
              height={14} 
              preview={false}
              style={{ cursor: 'pointer' }}
            />
          </Button>
        </Tooltip>
      </Flex>
    </Flex>
  );
};

export default CreditsNameInput;
